import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  background: ${(p) => p.theme.surface};
  border: 1px solid ${(p) => p.theme.border};
  border-radius: ${(p) => p.theme.radiusLg};
  box-shadow: ${(p) => p.theme.shadowSm};
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span.label {
    font-size: 0.8rem;
    font-weight: 600;
    color: ${(p) => p.theme.textMuted};
  }
`;

const IconBox = styled.div<{ $color?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: ${(p) => p.theme.radius};
  color: ${(p) => p.$color || p.theme.primary};
  background: ${(p) => (p.$color || p.theme.primary)}1a;
`;

const Value = styled.div`
  font-size: 1.6rem;
  font-weight: 800;
  color: ${(p) => p.theme.textPrimary};
  line-height: 1.1;
`;

const Delta = styled.div<{ $positive?: boolean }>`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${(p) => (p.$positive ? p.theme.success : p.theme.error)};
`;

interface StatCardProps {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  iconColor?: string;
  delta?: string;
  deltaPositive?: boolean;
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  icon,
  iconColor,
  delta,
  deltaPositive,
}) => (
  <Wrap>
    <Top>
      <span className="label">{label}</span>
      {icon && <IconBox $color={iconColor}>{icon}</IconBox>}
    </Top>
    <Value>{value}</Value>
    {delta && <Delta $positive={deltaPositive}>{delta}</Delta>}
  </Wrap>
);

export default StatCard;
